import { useQuery } from '@tanstack/react-query'

import { get } from '../../utils/api'
import { AnnotationLabels } from './types'

export const useAnnotationLabels = (productId: number) =>
  useQuery(
    ['labels', productId],
    () => get<AnnotationLabels>(`/labels/?product=${productId}`),
    {
      retry: false,
    }
  )
